import { PAYMENT_STATUS_LIST } from '../../../constants';

export const PAYMENT_TYPE_OPTIONS = [
  'Cash',
  'Check',
  'Credit Card',
  'Billing',
  'Financing',
  'Warranty',
  'Manufacturer Warranty',
  'Pre-Paid',
  'No Charge',
  'Internal Revenue Transfer',
  'ACH / Wire',
  'Charity',
] as const;

// Derived so it can't drift from the canonical list. 'Paid on contract' has to be among the
// options or editing such a contract silently rewrites the status.
export const PAYMENT_STATUS_OPTIONS: string[] = [...PAYMENT_STATUS_LIST];
